__turbopack_context__.v({
  "section": "ArticleBody-module-scss-module__oQZvRW__section",
});
